import PropTypes from "prop-types";
import { useIrreversible } from "features/compositions/services/useIrreversible";
import styles from "./Irreversible.module.css";

/**
 * Da li je nepovratna radnja zaista postala nepovratna.
 *
 * Blok u koji je transakcija ušla može pri račvi da otpadne. Do sada je GUI
 * govorio „gotovo" čim čvor odgovori — što je na jednom proizvođaču tačno posle
 * pola sekunde, a na pravoj mreži netačno još minutima.
 *
 * Stoji samo uz `handover` i brisanje baze. Za obične upise bi bio ukras: ono
 * što ne pokreće nijednu odluku ne zaslužuje mesto na ekranu.
 *
 * Četiri stanja, i „ne znam" je namerno odvojeno od „nije još":
 *
 *   idle      nema šta da se prati (radnja nije ni dirala lanac)
 *   waiting   zapisano, još može da otpadne
 *   final     nepovratno
 *   unknown   predugo se čeka — NE tvrdi se da je propalo
 */
const Irreversible = ({ blockNum }) => {
    const { state, irreversible } = useIrreversible(blockNum);

    if (state === "idle") return null;

    if (state === "waiting") {
        return (
            <p className={styles.waiting}>
                Recorded in block {blockNum}. Waiting for the chain to make it
                permanent — until then it can still be rolled back.
                {irreversible > 0 && ` ${blockNum - irreversible} block(s) to go.`}
            </p>
        );
    }

    if (state === "final") {
        return <p className={styles.final}>This is now permanent.</p>;
    }

    return (
        <p className={styles.unknown}>
            Block {blockNum} has not become permanent yet. That does not mean it
            failed — the chain or the node may simply be slow. Check again later.
        </p>
    );
};

Irreversible.propTypes = {
    blockNum: PropTypes.number,
};

export default Irreversible;
